import { IntentDto, IntentForm, IntentWithDatasetInfo } from "@closerplatform/spinner-openapi";
import { validateRequired, validateNoWhitespace, validateIntentName } from "@fidget/common/utils/validatorsFormState";
import { FormState, FieldState } from "formstate";
import { ChatInput, InputType } from "../../../models/room";
import {
    IntentDtoWithDatasetInfo,
    IntentWithDatasetInfoFormFields,
    IntentWithDatasetInfoFormType,
    NewIntentFormFields,
    NewIntentFormType
} from "./types";
import { validateIntentResponse } from "./validadors";

export const mapDtoWithDatasetInfoToForm = (intent: IntentDtoWithDatasetInfo): IntentWithDatasetInfoFormType => (
    new FormState<IntentWithDatasetInfoFormFields>({
        id: new FieldState(intent.id),
        orgId: new FieldState(intent.orgId),
        intent: new FieldState(intent.intent),
        locale: new FieldState(intent.locale),
        response: new FieldState(intent.response),
        context: new FieldState(intent.context),
        intentDescription: new FieldState(intent.intentDescription),
        createdAt: new FieldState(intent.createdAt),
        updatedAt: new FieldState(intent.updatedAt),
        deletedAt: new FieldState(intent.deletedAt),
        active: new FieldState(intent.active),
        datasetSize: new FieldState(intent.datasetSize),
        datasetChangedAt: new FieldState(intent.datasetChangedAt),

    })
);

export const mapIntentWithDatasetInfoFormTypeToIntentDto = (form: IntentWithDatasetInfoFormType): IntentDto => {
    return {
        id: form.$.id.$,
        orgId: form.$.orgId.$,
        intent: form.$.intent.$,
        locale: form.$.locale.$,
        response: form.$.response.$,
        context: form.$.context.$,
        intentDescription: form.$.intentDescription.$,
        createdAt: form.$.createdAt.$,
        updatedAt: form.$.updatedAt.$,
        deletedAt: form.$.deletedAt.$,
        active: form.$.active.$,
    };
};

export const mapFormToIntent = (form: IntentWithDatasetInfoFormType): IntentWithDatasetInfo => {
    return {
        intentDto: {
            id: form.$.id.$,
            orgId: form.$.orgId.$,
            intent: form.$.intent.$,
            locale: form.$.locale.$,
            response: form.$.response.$,
            context: form.$.context.$,
            intentDescription: form.$.intentDescription.$,
            createdAt: form.$.createdAt.$,
            updatedAt: form.$.updatedAt.$,
            deletedAt: form.$.deletedAt.$,
            active: form.$.active.$,
        },
        datasetSize: form.$.datasetSize.$,
        datasetChangedAt: form.$.datasetChangedAt.$,
    };
};

export const mapFormToDtoWithDatasetInfo = (form: IntentWithDatasetInfoFormType): IntentDtoWithDatasetInfo => {
    return {
        id: form.$.id.$,
        orgId: form.$.orgId.$,
        intent: form.$.intent.$,
        locale: form.$.locale.$,
        response: form.$.response.$,
        context: form.$.context.$,
        intentDescription: form.$.intentDescription.$,
        createdAt: form.$.createdAt.$,
        updatedAt: form.$.updatedAt.$,
        deletedAt: form.$.deletedAt.$,
        active: form.$.active.$,
        datasetSize: form.$.datasetSize.$,
        datasetChangedAt: form.$.datasetChangedAt.$,
    };
};

export const mapDtoToIntentWithDatasetInfo = (dto: IntentDto): IntentWithDatasetInfo =>
    ({ intentDto: dto, datasetSize: 0, datasetChangedAt: Date.now() });

export const mapDtoToDtoWithDatasetInfo = (dto: IntentDto): IntentDtoWithDatasetInfo =>
    ({ ...dto, datasetSize: 0, datasetChangedAt: Date.now() });

export const mapIntentWithDatasetInfoToDtoWithDatasetInfo =
    (intentWithDatasetInfo: IntentWithDatasetInfo): IntentDtoWithDatasetInfo => (
        {
            ...intentWithDatasetInfo.intentDto,
            datasetSize: intentWithDatasetInfo.datasetSize,
            datasetChangedAt: intentWithDatasetInfo.datasetChangedAt
        });

export const mapIntentWithDatasetInfoFormToUpdateForm = (intent: IntentWithDatasetInfoFormType): IntentForm => (
    {
        locale: intent.$.locale.$,
        intent: intent.$.intent.$,
        response: intent.$.response.$,
        context: intent.$.context.$,
        active: intent.$.active.$,
        intentDescription: intent.$.intentDescription.$,
    }
);

export const createNewIntentForm = (): NewIntentFormType => {
    return new FormState<NewIntentFormFields>({
        name: new FieldState("").validators(
            validateRequired,
            validateNoWhitespace,
            validateIntentName
        ),
        response: new FieldState(
            ChatInput.create({ activeInputType: InputType.Message, fileStore: {} }))
            .validators(validateIntentResponse),
    });
};

export const copyExistingIntentForm = (form: IntentWithDatasetInfoFormType): IntentWithDatasetInfoFormType => {
    return new FormState<IntentWithDatasetInfoFormFields>({
        id: new FieldState(form.$.id.$),
        orgId: new FieldState(form.$.orgId.$),
        intent: new FieldState(form.$.intent.$),
        locale: new FieldState(form.$.locale.$),
        response: new FieldState(form.$.response.$),
        context: new FieldState(form.$.context.$),
        intentDescription: new FieldState(form.$.intentDescription.$),
        createdAt: new FieldState(form.$.createdAt.$),
        updatedAt: new FieldState(form.$.updatedAt.$),
        deletedAt: new FieldState(form.$.deletedAt.$),
        active: new FieldState(form.$.active.$),
        datasetSize: new FieldState(form.$.datasetSize.$),
        datasetChangedAt: new FieldState(form.$.datasetChangedAt.$),
    });
};

export const mapIntentDtoToUpdateForm = (dto: IntentDto): IntentForm => (
    {
        locale: dto.locale,
        intent: dto.intent,
        response: dto.response,
        context: dto.context,
        active: dto.active,
        intentDescription: dto.intentDescription
    }
);
